import type { GameNavItem } from "@/app/constants-nav.mjs";

/**
 * Auto generated code with command:
 *   npx tsx build-scripts/cs2-links.mjs
 */
export const DATABASE_LINKS: GameNavItem[] = [
  {
    href: "/cs2/database/weapons",
    text: ["common:navigation.weapons", "Weapons"],
    menu: [
      [
        {
          items: [
            {
              href: "/cs2/database/weapons?category=pistols",
              text: ["cs2:weaponCategories.pistols", "Pistols"],
              menu: {
                items: [
                  {
                    href: "/cs2/database/weapons/weapon_deagle/overview",
                    text: ["weaponDeagle", "Desert Eagle"],
                  },
                  {
                    href: "/cs2/database/weapons/weapon_elite/overview",
                    text: ["weaponElite", "Dual Berettas"],
                  },
                  {
                    href: "/cs2/database/weapons/weapon_fiveseven/overview",
                    text: ["weaponFiveseven", "Five-SeveN"],
                  },
                  {
                    href: "/cs2/database/weapons/weapon_glock/overview",
                    text: ["weaponGlock", "Glock-18"],
                  },
                  {
                    href: "/cs2/database/weapons/weapon_tec9/overview",
                    text: ["weaponTec9", "Tec-9"],
                  },
                  {
                    href: "/cs2/database/weapons/weapon_hkp2000/overview",
                    text: ["weaponHkp2000", "P2000"],
                  },
                  {
                    href: "/cs2/database/weapons/weapon_p250/overview",
                    text: ["weaponP250", "P250"],
                  },
                  {
                    href: "/cs2/database/weapons/weapon_usp_silencer/overview",
                    text: ["weaponUspSilencer", "USP-S"],
                  },
                  {
                    href: "/cs2/database/weapons/weapon_cz75a/overview",
                    text: ["weaponCz75a", "CZ75-Auto"],
                  },
                  {
                    href: "/cs2/database/weapons/weapon_revolver/overview",
                    text: ["weaponRevolver", "R8 Revolver"],
                  },
                ],
              },
            },
            {
              href: "/cs2/database/weapons?category=shotguns",
              text: ["cs2:weaponCategories.shotguns", "Shotguns"],
              menu: {
                items: [
                  {
                    href: "/cs2/database/weapons/weapon_xm1014/overview",
                    text: ["weaponXm1014", "XM1014"],
                  },
                  {
                    href: "/cs2/database/weapons/weapon_mag7/overview",
                    text: ["weaponMag7", "MAG-7"],
                  },
                  {
                    href: "/cs2/database/weapons/weapon_sawedoff/overview",
                    text: ["weaponSawedoff", "Sawed-Off"],
                  },
                  {
                    href: "/cs2/database/weapons/weapon_nova/overview",
                    text: ["weaponNova", "Nova"],
                  },
                ],
              },
            },
            {
              href: "/cs2/database/weapons?category=smgs",
              text: ["cs2:weaponCategories.smgs", "SMGs"],
              menu: {
                items: [
                  {
                    href: "/cs2/database/weapons/weapon_mac_10/overview",
                    text: ["weaponMac_10", "MAC-10"],
                  },
                  {
                    href: "/cs2/database/weapons/weapon_mp5sd/overview",
                    text: ["weaponMp5sd", "MP5-SD"],
                  },
                  {
                    href: "/cs2/database/weapons/weapon_p90/overview",
                    text: ["weaponP90", "P90"],
                  },
                  {
                    href: "/cs2/database/weapons/weapon_ump45/overview",
                    text: ["weaponUmp45", "UMP-45"],
                  },
                  {
                    href: "/cs2/database/weapons/weapon_bizon/overview",
                    text: ["weaponBizon", "PP-Bizon"],
                  },
                  {
                    href: "/cs2/database/weapons/weapon_mp7/overview",
                    text: ["weaponMp7", "MP7"],
                  },
                  {
                    href: "/cs2/database/weapons/weapon_mp9/overview",
                    text: ["weaponMp9", "MP9"],
                  },
                ],
              },
            },
            {
              href: "/cs2/database/weapons?category=rifles",
              text: ["cs2:weaponCategories.rifle", "Rifles"],
              menu: {
                items: [
                  {
                    href: "/cs2/database/weapons/weapon_ak47/overview",
                    text: ["weaponAk47", "AK-47"],
                  },
                  {
                    href: "/cs2/database/weapons/weapon_aug/overview",
                    text: ["weaponAug", "AUG"],
                  },
                  {
                    href: "/cs2/database/weapons/weapon_famas/overview",
                    text: ["weaponFamas", "FAMAS"],
                  },
                  {
                    href: "/cs2/database/weapons/weapon_galilar/overview",
                    text: ["weaponGalilar", "Galil AR"],
                  },
                  {
                    href: "/cs2/database/weapons/weapon_m4a1/overview",
                    text: ["weaponM4a1", "M4A4"],
                  },
                  {
                    href: "/cs2/database/weapons/weapon_sg556/overview",
                    text: ["weaponSg556", "SG 553"],
                  },
                  {
                    href: "/cs2/database/weapons/weapon_m4a1_silencer/overview",
                    text: ["weaponM4a1Silencer", "M4A1-S"],
                  },
                ],
              },
            },
            {
              href: "/cs2/database/weapons?category=heavy",
              text: ["cs2:weaponCategories.heavy", "Heavy"],
              menu: {
                items: [
                  {
                    href: "/cs2/database/weapons/weapon_m249/overview",
                    text: ["weaponM249", "M249"],
                  },
                  {
                    href: "/cs2/database/weapons/weapon_negev/overview",
                    text: ["weaponNegev", "Negev"],
                  },
                ],
              },
            },
            {
              href: "/cs2/database/weapons?category=snipers",
              text: ["cs2:weaponCategories.sniper", "Snipers"],
              menu: {
                items: [
                  {
                    href: "/cs2/database/weapons/weapon_awp/overview",
                    text: ["weaponAwp", "AWP"],
                  },
                  {
                    href: "/cs2/database/weapons/weapon_g3sg1/overview",
                    text: ["weaponG3sg1", "G3SG1"],
                  },
                  {
                    href: "/cs2/database/weapons/weapon_ssg08/overview",
                    text: ["weaponSsg08", "SSG 08"],
                  },
                  {
                    href: "/cs2/database/weapons/weapon_scar20/overview",
                    text: ["weaponScar20", "SCAR-20"],
                  },
                ],
              },
            },
          ],
        },
      ],
    ],
  },
  {
    href: "/cs2/database/weapons",
    text: ["common:navigation.equipment", "Equipment"],
    menu: [
      [
        {
          items: [
            {
              text: ["weaponDecoy", "Decoy Grenade"],
              href: "/cs2/database/weapons/weapon_decoy/overview",
            },
            {
              text: ["weaponHegrenade", "HE Grenade"],
              href: "/cs2/database/weapons/weapon_hegrenade/overview",
            },
            {
              text: ["weaponIncgrenade", "Incendiary Grenade"],
              href: "/cs2/database/weapons/weapon_incgrenade/overview",
            },
            {
              text: ["weaponFlashbang", "Flash Bang"],
              href: "/cs2/database/weapons/weapon_flashbang/overview",
            },
            {
              text: ["weaponSmoke", "Smoke"],
              href: "/cs2/database/weapons/weapon_smoke/overview",
            },
            {
              text: ["kevlarAndHelmet", "Kevlar + Helmet"],
              href: "/cs2/database/weapons/kevlarAndHelmet/overview",
            },
          ],
        },
      ],
    ],
  },
  {
    href: "/cs2/database/maps",
    text: ["common:navigation.maps", "Maps"],
    menu: [
      [
        {
          items: [
            {
              text: ["deMirage", "Mirage"],
              href: "/cs2/database/maps/de_mirage/overview",
            },
            {
              text: ["deDust2", "Dust II"],
              href: "/cs2/database/maps/de_dust2/overview",
            },
            {
              text: ["deInferno", "Inferno"],
              href: "/cs2/database/maps/de_inferno/overview",
            },
            {
              text: ["deOverpass", "Overpass"],
              href: "/cs2/database/maps/de_overpass/overview",
            },
            {
              text: ["deNuke", "Nuke"],
              href: "/cs2/database/maps/de_nuke/overview",
            },
            {
              text: ["deAncient", "Ancient"],
              href: "/cs2/database/maps/de_ancient/overview",
            },
            {
              text: ["common:navigation.others", "Others"],
              href: "/cs2/database/maps/de_anubis/overview",
              menu: {
                items: [
                  {
                    text: ["deAnubis", "Anubis"],
                    href: "/cs2/database/maps/de_anubis/overview",
                  },
                  {
                    text: ["deVertigo", "Vertigo"],
                    href: "/cs2/database/maps/de_vertigo/overview",
                  },
                  {
                    text: ["deCbble", "Cobblestone"],
                    href: "/cs2/database/maps/de_cbble/overview",
                  },
                  {
                    text: ["deTrain", "Train"],
                    href: "/cs2/database/maps/de_train/overview",
                  },
                  {
                    text: ["deTuscan", "Tuscan"],
                    href: "/cs2/database/maps/de_tuscan/overview",
                  },
                  {
                    text: ["deCanals", "Canals"],
                    href: "/cs2/database/maps/de_canals/overview",
                  },
                ],
              },
            },
          ],
        },
      ],
    ],
  },
];
